import { render } from "./CliCoverAcceptanceTab.vue?vue&type=template&id=01fb200e&ts=true"
import script from "./CliCoverAcceptanceTab.vue?vue&type=script&lang=ts"
export * from "./CliCoverAcceptanceTab.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__